import { fabric } from 'fabric';
import { DisplayOptions } from '@/types/tower/Tower';
import CanvasUtils from '@/utilities/tower/v2/Canvas';
import { ProgramPolicyItem } from '@/views/tower/v2/objects/ProgramsLibraryPanel';

export default fabric.util.createClass(fabric.Canvas, {
  constructor(canvas: HTMLCanvasElement | string, opts: fabric.TowerCanvasOptions) {
    opts = opts || {};
    this.gridModeEnabled = opts.gridModeEnabled || false;
    this.displayOptions = opts.displayOptions;
    this.snapToModeEnabled = opts.snapToModeEnabled || true;
    this.zoomLevel = opts.zoomLevel || CanvasUtils.DEFAULT_ZOOM;
    this.viewportTransform = opts.viewportTransform || [1, 0, 0, 1, 0, 0];
    this.customPolicies = opts.customPolicies || [];
    this.renewalProcessed = opts.renewalProcessed || false;

    this.callSuper('constructor', canvas, opts);
  },
  initialize(canvas: HTMLCanvasElement | string, opts: fabric.TowerCanvasOptions) {
    opts = opts || {};
    this.gridModeEnabled = opts.gridModeEnabled || false;
    this.displayOptions = opts.displayOptions;
    this.snapToModeEnabled = opts.snapToModeEnabled || true;

    this.callSuper('initialize', canvas, opts);
  },

  setGridMode(mode: boolean): void {
    this.gridModeEnabled = mode;
  },

  setZoomLevel(zoomLevel: number): void {
    this.zoomLevel = zoomLevel;
  },

  setDisplayOptions(displayOptions?: DisplayOptions): void {
    this.displayOptions = displayOptions;
  },

  setSnapToMode(mode: boolean): void {
    this.snapToModeEnabled = mode;
  },

  setViewportTransform(vpt: number[]): void {
    this.viewportTransform = vpt;
  },

  setCustomPolicies(customPolicies: ProgramPolicyItem[]): void {
    this.customPolicies = customPolicies;
  },

  setRenewalProcessed(renewalProcessed: boolean): void {
   this.renewalProcessed = renewalProcessed;
  }
});

